import type { ProcessEngineTask } from '../../../../enum';

export enum IBsiCreateNoInterestProductKind {
    ACCOUNT = '1',
    CARD = '2',
    THIRD_PARTY = '3',
}

export interface IBsiCreateNoInterestRequest {
    productKind: IBsiCreateNoInterestProductKind; // maxlength: 2, enum
    productType: string; // product type (finnova card type, CARD_ART_NR or KT1ART or other tbd. codes)
    notes?: string; // maxlength: 250, free text
}

export interface IBsiCreateNoInterestTask {
    taskType: ProcessEngineTask.CREATE_NO_INTEREST;
    BsiCaseInput: IBsiCreateNoInterestRequest;
}
